export function toPredictsViewModel(predictRanges) {
  const predictArrays = predictRanges.map(x => {
    const arr = [];
    for (let i = x.from; i <= x.to; i = i + x.step) {
      arr.push(i);
    }
    x['predicts'] = arr;
    return arr;
  });

  const result = predictArrays.flat();
  return result;
}